import { domClassMerge } from '@propertyfinder/helpers';
import { FunctionalComponent, h } from 'preact';

import { configGetLanguage } from 'common/helper/config/get-language';
import { dateToLocale } from 'common/helper/date/to-locale';
import { i18nTranslate } from 'common/helper/i18n/translate';
import { PropertyLastContactedTemplatePropsInterface } from 'common/module/property/last-contacted/template-props.interface';

import { LastContactedIconTemplate } from './icon.template';

export const PropertyLastContactedTemplate: FunctionalComponent<PropertyLastContactedTemplatePropsInterface> = (
  props
) => {
  if (!props.lastContacted) {
    return null;
  }

  return (
    <div className={domClassMerge('card__contacted-date', props.class)}>
      <LastContactedIconTemplate
        className={domClassMerge('card__contacted-date-icon', props.iconClassName)}
        type={props.lastContacted.contact_type}
      />
      <span>{i18nTranslate('Last contacted on')}:</span>
      <span>
        <b>{dateToLocale(props.lastContacted.contact_date, configGetLanguage().current)}</b>
      </span>
    </div>
  );
};
